import React from 'react';
import './wizardao.css';

const Home = () => {
return (
	
	

	<div class="onetextw"> 
      <form id="webbutton" action="https://mobile-app.pixanft.com">
        <input id="webbutton" type="submit" value="Mobile Website" />
      </form> 
	  <br></br>
	<h4>This site is optimized for desktop use. Access mobile site using button above.</h4> 

    
	<h1>🔼  Use navigation bar above to access Pixa web3 apps 🔼</h1>  

	Terms and Conditions (applies to all Pixa sites): Your purchase of Pixa NFTs does NOT CONSTITUTE AN INVESTMENT. Purchase of these NFTs from Pixa is meant for entertainment purposes only. Pixa makes no warranties regarding future value, express or implied, to the public or to buyers. Only purchase if you wish to own the artwork and nothing else. Only purchase with the current state of the project in mind and the assumption that no future value will be delivered. Pixa NFTs and $PIXA tokens are not currency and do not convey ownership in Pixa or its assets. You are purchasing a digital collectible, we do not guarantee any future development around these NFTs. $PIXA tokens are not shares or securities of any type. Holding a token does not entitle the holder to any ownership or other interest in Pixa, future business operations, future revenue, or any control or ability to bind the entity. $PIXA tokens are merely a means by which you may be able to utilize certain services such as changing aspects of the artwork in your Pixa NFT. There is no guarantee that the PixaRealm platform will actually be developed, although we guarantee that it is our intention to do so.</div>
);
};

export default Home;
